import { useLocation } from "react-router-dom";
import SEO from "./SEO";
import SEOConfig, { publisherRef } from "./SEOConfig";

// The page mirrors its tab, simulator and filters into the query string; those are views of one
// page, so the canonical is the bare path.
const HallOfFameSEO = () => {
  const location = useLocation();
  const { siteUrl } = SEOConfig;
  const currentUrl = `${siteUrl}${location.pathname}`;

  const title = "Зала слави: чемпіони і рекорди";
  const description =
    "Зала слави формульної ліги симрейсингу Slick Racing Ukraine: чемпіони, рекорди пілотів і команд та найшвидші кола на кожній трасі в iRacing.";

  const keywords = [
    "Slick Racing Ukraine зала слави",
    "чемпіони симрейсинг",
    "чемпіони сімрейсінг",
    "рекорди iRacing",
    "найшвидші кола",
    "статистика пілотів",
    "українська симрейсинг ліга",
    "українська сімрейсінг ліга",
  ];

  const breadcrumbs = [
    { name: "Головна", url: siteUrl },
    { name: "Зала слави", url: currentUrl },
  ];

  const schema = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name: title,
    description,
    url: currentUrl,
    inLanguage: "uk",
    publisher: publisherRef,
  };

  return (
    <SEO
      title={title}
      description={description}
      keywords={keywords}
      url={currentUrl}
      schema={schema}
      canonical={currentUrl}
      type="website"
      breadcrumbs={breadcrumbs}
      lang="uk"
    />
  );
};

export default HallOfFameSEO;
